export const footerContainer = {
  bgcolor: 'background.paper',
  borderTop: '1px solid',
  borderColor: 'divider',
  pt: 6,
  pb: 3,
};

export const logoBox = {
  display: 'flex',
  alignItems: 'center',
  mb: 2,
};

export const logoImage = {
  width: 48,
  height: 48,
  borderRadius: '50%',
  objectFit: 'contain',
  mr: 1.5,
};

export const linkItem = {
  display: 'block',
  mb: 0.5,
};

export const contactItem = {
  display: 'flex',
  alignItems: 'center',
  mb: 1,
  color: 'text.secondary',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
};

export const iconStyle = {
  mr: 1,
};

export const dividerStyle = {
  my: 4,
};

export const copyrightStyle = {
  fontSize: '0.875rem',
  textAlign: 'center',
};
